export default __webpack_public_path__ + "static/media/batchesicon.41f3710c.png";